import React, { useEffect } from 'react';
import posed from 'react-pose';
import styled from 'styled-components';
import { Icon } from '@cowsquare/design';
import { themeGet } from '@styled-system/theme-get';

const Frame = posed.div({
  init: {
    applyAtEnd: { display: 'none' },
    opacity: 0,
  },
  zoom: {
    applyAtStart: { display: 'block' },
    opacity: 1,
  },
});

const transition = {
  duration: 400,
  ease: [0.08, 0.69, 0.2, 0.99],
};

const ImageAnimation = posed.div({
  init: {
    position: 'static',
    width: 'auto',
    height: 'auto',
    transition,
    flip: true,
  },
  zoom: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    transition,
    flip: true,
  },
});

const Image = styled(ImageAnimation)`
  width: 100%;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-position: center center;
  background-color: ${props => (props.pose === 'zoom' ? 'black' : '#e8e8e8')};
  background-size: ${props => (props.pose === 'zoom' ? 'contain' : 'cover')};
  cursor: pointer;
  z-index: ${themeGet('zIndex.fixed')};

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  &:hover {
    filter: ${props => (props.pose === 'zoom' ? 'none' : 'brightness(80%)')};
  }
`;

const CloseButtonAnimation = posed(Icon)({
  init: {
    applyAtEnd: { display: 'none' },
    opacity: 0,
  },
  zoom: {
    applyAtStart: { display: 'block' },
    opacity: 1,
  },
});

const CloseButton = styled(CloseButtonAnimation).attrs({
  name: 'close',
  fontSize: 30,
  color: 'white',
})`
  position: fixed;
  top: 20px;
  right: 20px;
  cursor: pointer;
  z-index: ${themeGet('zIndex.fixed')};
`;

const ZoomImage = props => {
  const [isZoomed, setIsZoomed] = React.useState(false);
  const toggleZoom = React.useCallback(() => setIsZoomed(isZoomed => !isZoomed), []);
  const zoomOut = React.useCallback(() => setIsZoomed(false), []);

  useEffect(() => {
    if (isZoomed) {
      window.addEventListener('scroll', zoomOut);
    }
    return () => {
      window.removeEventListener('scroll', zoomOut);
    };
  }, [isZoomed, zoomOut]);

  const pose = isZoomed ? 'zoom' : 'init';

  return (
    <div onClick={toggleZoom}>
      <Frame pose={pose} className="frame" />
      <Image pose={pose} {...props} />
      <CloseButton pose={pose} />
    </div>
  );
};

export default ZoomImage;
